import { connect } from 'react-redux';

import withDeleteModal from '../hoc/withDeleteModal';
import { removeObject } from 'api/brands/removeBrand';
import { removeBrand } from 'actions/user';

const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return {
    reduxRemover: brand => dispatch(removeBrand(brand)),
  };
};

const DeleteBrandModal = withDeleteModal({
  itemLabel: 'brand',
  request: removeObject,
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteBrandModal);
